import { Icon } from '@studio/design-system/icon';
import * as Tabs from '@studio/design-system/tabs';
import type { ReactElement } from 'react';
import type { TriggersProps } from './types.js';
import { Tab } from './types.js';
import { Sel, STag, DataSTag } from '#~/stag/index.js';

/** @internal */
export const Triggers = ({
  audioCount = 0,
  children,
  disabled,
  videoCount = 0,
  ...props
}: TriggersProps): ReactElement => (
  <Tabs.List {...props}>
    <Tabs.Trigger
      disabled={disabled}
      value={Tab.Video}
      {...STag(Sel.MainRoomLeftTrayHeader, 'tabs', 'video')}
    >
      <Icon icon='source' />
      Video (<span {...DataSTag(Sel.MainRoomLeftTrayHeader, 'video-count')}>{videoCount}</span>)
    </Tabs.Trigger>

    <Tabs.Trigger
      disabled={disabled}
      value={Tab.Audio}
      {...STag(Sel.MainRoomLeftTrayHeader, 'tabs', 'audio')}
    >
      <Icon icon='audio' />
      Audio (<span {...DataSTag(Sel.MainRoomLeftTrayHeader, 'audio-count')}>{audioCount}</span>)
    </Tabs.Trigger>

    {children}
  </Tabs.List>
);
